import type { IconSvgObject } from './types';

const ListVideoIcon: IconSvgObject = [
  ["path", { d: "M3 5H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 12H9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3 19H9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M14 11.7872V18.2128C14 18.6476 14.3524 19 14.7872 19C14.9266 19 15.0634 18.963 15.1838 18.8928L20.5681 15.7519C20.8355 15.5959 21 15.3096 21 15C21 14.6904 20.8355 14.4041 20.5681 14.2481L15.1838 11.1072C15.0634 11.037 14.9266 11 14.7872 11C14.3524 11 14 11.3524 14 11.7872Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default ListVideoIcon;
